import { InputField } from "components/InputField/Input";
import { CommonButton } from "components/Buttons/Buttons";
import { BiMinus, BiPlus } from "react-icons/bi";
import useItemDropdown from "./useItemDropdown";
import { dropdownFunction } from "utilities/dropdownFunction";

const useAssignmentDataTable = (formik, setDeleteAssignmentID, setShowDeleteAssignmentModal, showForm) => {
    const addItemOnChange = (e, i, fieldName) => {
        formik.setFieldValue(`assignment[${i}].${fieldName}`, e?.value || e?.target?.value);
    };

    const {
        vendorNameDropdown, 
        setVendorNameDropdown, 
        employeeNameDropdown,
        setEmployeeNameDropdown,
        vendorNameList,
        employeeNameList,
    } = useItemDropdown(showForm);

    const modalAssignmentTableColumns = [
        {
            field: "assign_to",
            header: "Employee",
            sortableBody: (value, event) => (
                <div className="w-50">
                    <InputField
                        id="assign_to"
                        name="assign_to"
                        autoFilteredValue={employeeNameDropdown}
                        autoCompleteMethod={(event) => dropdownFunction(event, setEmployeeNameDropdown, employeeNameList)}
                        onChange={(e) => addItemOnChange(e, event.rowIndex, "assign_to")}
                        value={formik.values.assignment[event.rowIndex]?.assign_to}
                        type="select"
                        label="Select Employee"
                        width="full"
                        autoCompleteFieldName="name"
                        required={false}
                        errors={formik.errors.assignment?.[event.rowIndex]?.assign_to}
                    />
                </div>
            ),
        },
        {
            field: "assign_date",
            header: "Assign Date",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="assign_date"
                        name="assign_date"
                        onChange={(e) => addItemOnChange(e, event.rowIndex, "assign_date")}
                        value={formik.values.assignment[event.rowIndex]?.assign_date}
                        type="date"
                        width="full"
                        autoCompleteFieldName="name"
                        required={true}
                        messagePosition='bottom'
                        errors={formik.errors.assignment?.[event.rowIndex]?.assign_date}
                    />
                </div>
            ),
        },
        {
            field: "return_date",
            header: "Return Date",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="return_date"
                        name="return_date"
                        onChange={(e) => addItemOnChange(e, event.rowIndex, "return_date")}
                        value={formik.values.assignment[event.rowIndex]?.return_date}
                        type="date"
                        width="full"
                        autoCompleteFieldName="return_date"
                        required={false}
                        messagePosition='bottom'
                        errors={formik.errors.assignment?.[event.rowIndex]?.return_date}
                    />
                </div>
            ),
        },
        {
            field: "remark",
            header: "Remark",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="remark"
                        name="remark"
                        onChange={(e) => addItemOnChange(e, event.rowIndex, "remark")}
                        value={formik.values.assignment[event.rowIndex]?.remark}
                        type="text"
                        width="full"
                        autoCompleteFieldName="remark"
                        required={false}
                        messagePosition='bottom'
                        errors={formik.errors.assignment?.[event.rowIndex]?.remark}
                    />
                </div>
            ),
        },
    ]

    const deleteAssignmentItems = (rowData) => {
        const {id, asset} = rowData;
        setDeleteAssignmentID({id, asset})
        setShowDeleteAssignmentModal(true)
    }

    const modalAssignmentTableActionButton = (rowData, {rowIndex}) => {
        const handleOnFieldIncrement = () => {
            const joinData = formik.values.assignment.concat({
                fieldId: rowIndex + 1,
                assign_to: "",
                assign_date: "",
                return_date: "",
                remark: "",
            });
            formik.setFieldValue("assignment", joinData)
        };

        const handleOnFieldDecrement = (i) => {
            if(rowData.id > 0){
                return deleteAssignmentItems(rowData)
            }
            const removeData = [...formik.values.assignment];
            removeData.splice(rowIndex, 1);
            formik.setFieldValue("assignment", removeData);
        };

        return (
            <>
                <div className="flex items-center justify-center">
                    {
                        formik.values.assignment.length - 1 === rowIndex ? (
                            <>
                                <CommonButton 
                                    icon={<BiPlus className="text-green-700 text-2xl" />}
                                    className="p-button-rounded p-mr-2 action-button-green"
                                    title=""
                                    type="button"
                                    onClick={handleOnFieldIncrement}
                                />
                                {formik.values.assignment.length !== 1 && 
                                <CommonButton 
                                    icon={<BiMinus className="text-red-700 text-2xl" />} 
                                    className="p-button-rounded p-mr-2 action-button-red" 
                                    title="" 
                                    type="button" 
                                    onClick={handleOnFieldDecrement} 
                                />}
                            </>
                        ) : 
                        (
                            <>
                                <CommonButton 
                                    icon={<BiMinus className="text-red-700 text-2xl" />} 
                                    className="p-button-rounded p-mr-2 action-button-red" 
                                    title="" 
                                    type="button" 
                                    onClick={handleOnFieldDecrement} 
                                />
                            </>
                        )
                    }
                </div>
            </>
        )
    }

    return {
        modalAssignmentTableColumns,
        modalAssignmentTableActionButton,
    }
}

export default useAssignmentDataTable